module.exports = __webpack_public_path__ + "media/newstyle/images/dictionary-53b59244b7fc66f6a8ace8688f4aba35.svg";